import apiService from './apiService';

const aiAgentService = {
  // Action execution methods
  async createLead(leadData) {
    try {
      const response = await apiService.post('/ai-agent/actions/create-lead', leadData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateLead(leadId, updateData) {
    try {
      const response = await apiService.put(`/ai-agent/actions/update-lead/${leadId}`, updateData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async createDeal(dealData) {
    try {
      const response = await apiService.post('/ai-agent/actions/create-deal', dealData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async createMeeting(meetingData) {
    try {
      const response = await apiService.post('/ai-agent/actions/create-meeting', meetingData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async createTask(taskData) {
    try {
      const response = await apiService.post('/ai-agent/actions/create-task', taskData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Chat methods
  async sendMessage(message, sessionId) {
    try {
      const response = await apiService.post('/ai-agent/chat', { message, sessionId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async createSession(initialMessage) {
    try {
      const response = await apiService.post('/ai-agent/session', { initialMessage });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getCapabilities() {
    try {
      const response = await apiService.get('/ai-agent/capabilities');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default aiAgentService;
